import { comparisonModes } from '../../constants'

export default {
  TYPES: comparisonModes,
  computed: {
    isValueFieldDisabled() {
      return [
        comparisonModes.SHOW_ALL,
        comparisonModes.TRUE,
        comparisonModes.FALSE,
      ].includes(this.comparisonMode)
    },

    isValueFieldHidden() {
      return this.comparisonMode === comparisonModes.SHOW_ALL
    },

    comparisonModes() {
      return this.filter.comparisonModes()
    },

    numberComparisonModes() {
      return [
        {
          label: '=',
          value: comparisonModes.EQUAL,
          visibleFor: ['date-input'],
        },
        {
          label: '≠',
          value: comparisonModes.NOT_EQUAL,
          visibleFor: ['date-input'],
        },
        {
          label: '<',
          value: comparisonModes.LESS_THAN,
          visibleFor: ['date-input'],
        },
        {
          label: '>',
          value: comparisonModes.GREATER_THAN,
          visibleFor: ['date-input'],
        },
        {
          label: '≤',
          value: comparisonModes.LESS_THAN_OR_EQUAL,
          visibleFor: ['date-input'],
        },
        {
          label: '≥',
          value: comparisonModes.GREATER_THAN_OR_EQUAL,
          visibleFor: ['date-input'],
        },
      ]
    },

    showAllComparisonMode({ customLabel = null } = {}) {
      return [
        {
          label:
            customLabel ||
            I18n.t('companies_overview.filters.comparison_modes.show_all'),
          value: comparisonModes.SHOW_ALL,
          visibleFor: ['input', 'dropdown', 'checkbox', 'date-input'],
        },
      ]
    },

    isComparisonMode({ customLabel = null } = {}) {
      return [
        {
          label:
            customLabel ||
            I18n.t('companies_overview.filters.comparison_modes.is'),
          value: comparisonModes.IS,
          visibleFor: ['dropdown'],
        },
      ]
    },

    isNotComparisonMode({ customLabel = null } = {}) {
      return [
        {
          label:
            customLabel ||
            I18n.t('companies_overview.filters.comparison_modes.is_not'),
          value: comparisonModes.IS_NOT,
          visibleFor: ['dropdown'],
        },
      ]
    },

    untilStatusComparisonMode() {
      return [
        {
          label: I18n.t(
            'companies_overview.filters.comparison_modes.up_to_status'
          ),
          value: comparisonModes.UP_TO_STATUS,
          visibleFor: ['dropdown'],
        },
      ]
    },

    fromStatusComparisonMode() {
      return [
        {
          label: I18n.t(
            'companies_overview.filters.comparison_modes.from_status'
          ),
          value: comparisonModes.FROM_STATUS,
          visibleFor: ['dropdown'],
        },
      ]
    },

    textComparisonModes() {
      return [
        {
          label: I18n.t(
            'companies_overview.filters.comparison_modes.containing'
          ),
          value: comparisonModes.CONTAINS,
          visibleFor: ['input'],
        },
        {
          label: I18n.t('companies_overview.filters.comparison_modes.equal_to'),
          value: comparisonModes.EXACTLY,
          visibleFor: ['input', 'date-input'],
        },
      ]
    },

    booleanComparisonModes() {
      return [
        {
          label: I18n.t('companies_overview.filters.comparison_modes.true'),
          value: comparisonModes.TRUE,
          visibleFor: ['checkbox'],
        },
        {
          label: I18n.t('companies_overview.filters.comparison_modes.false'),
          value: comparisonModes.FALSE,
          visibleFor: ['checkbox'],
        },
      ]
    },
  },
}
